<template>
  <div>
    <div v-if="dataloaded">
      <div class="sm:hidden fixed bottom-0 w-full z-[11]">
        <div v-if="acco.url"
          class="shadow-2xl p-4 flex justify-between items-center bg-white mobileBottomPadding dark:bg-neutral-900 border-t border-gray-200 dark:border-neutral-700 dark:text-white w-full mx-auto">
          <a target="_blank" :href="acco.url + '?referrer=' + referrer"
            class="block w-full bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
            <span>{{ $t('Go to website') }}</span>
          </a>
        </div>
        <div v-else
          class="shadow-2xl p-4 flex justify-between items-center bg-white mobileBottomPadding dark:bg-neutral-900 border-t border-gray-200 dark:border-neutral-700 dark:text-white w-full mx-auto"
          @click="openMenu()">
          <div class="">
            <div v-if="this.prices.price" class="booknowbottom">
              <span>€ {{ (this.prices.roomPrice + extraCosts).toFixed(2) }} - {{ $t('Book now!') }}</span>
            </div>
            <span v-else>{{ $t('See availability') }}</span>
          </div>
          <div class="h-12 flex items-center justify-center">
            <span class="text-xs mr-4 text-gray-500 dark:text-gray">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor"
                viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                <path
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
              </svg>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
              viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
              <path
                d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row header">
          <div>
            <h1 class="text-2xl font-bold text-center md:text-left dark:text-white mt-6 md2:mt-10">{{ acco.name }}</h1>
            <div class="location  text-center md:text-left text-opacity-90 dark:text-primary">
              <span><a v-bind:href="`${currentUrl}/accomodations?city=${acco.city}`">
                  {{ acco.city }}
                </a></span>,
              <span><a v-bind:href="`${currentUrl}/accomodations?state=${acco.state}`">
                  {{ acco.state }}
                </a></span>,
              <span><a v-bind:href="`${currentUrl}/accomodations?country=${acco.country}`">
                  {{ acco.country }}
                </a></span>
            </div>
          </div>
          <div class="socials d-md-none">
            <a :href="`https://x.com/share?url=${currentUrl}/accomodations/${acco.id}&text=${acco.name}`" target="_blank"
              class="mx1 w-8 h-8 -translate-y-3 hover:scale-95 active:scale-75 transition duration-300 cursor-pointer dark:text-white">
              <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 1200 1227" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
              </svg>

            </a>
            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}/accomodations/${acco.id}`"
              target="_blank"
              class="mx1 w-8 h-8 -translate-y-3 hover:scale-95 active:scale-75 transition duration-300 cursor-pointer hover:brightness-125">
              <img v-bind:src="currentUrl + '/images/icons/facebook.svg'" alt="" srcset="" />
            </a>
            <div v-if="webShareApiSupported" @click.prevent="shareViaWebShare()"
              class="mx1 pointer w-8 h-8 -translate-y-3">
                <svg-vue class="dark:invert" :icon="'share'"></svg-vue>
            </div>
          </div>
        </div>
        <div class="row noflex relative">
          <div v-if="images.length >= 5" class="imagebox mb-5 mt-6 md:my-10 rounded-lg max-h-[40vh] md2:max-h-[50vh]"
            v-viewer="viewerOptions">
            <vue-load-image>
              <img slot="image"
                class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable rounded-xl md2:rounded-r-none"
                :src="mipmap(images[0].fullUrl, 800)" alt="" :key="'accopage' + images[0].src" loading="eager"
                :data-href="images[0].href">
              <img slot="preloader"
                class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700 rounded-xl md2:rounded-r-none"
                loading="eager" :src="mipmap(images[0].fullUrl, 10)" alt="" :key="'accopage' + images[0].src"
                :data-href="images[0].href">
            </vue-load-image>
            <div class="grid">
              <vue-load-image>
                <img slot="image"
                  class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable"
                  loading="eager" :src="mipmap(images[1].fullUrl, 400)" alt="" :key="'accopage' + images[1].src"
                  :data-href="images[1].href">
                <img slot="preloader"
                  class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700" loading="lazy"
                  :src="mipmap(images[1].fullUrl, 10)" alt="" :key="'accopage' + images[1].src"
                  :data-href="images[1].href">
              </vue-load-image>
              <vue-load-image>
                <img slot="image"
                  class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable rounded-tr-xl"
                  loading="eager" :src="mipmap(images[2].fullUrl, 400)" alt="" :key="'accopage' + images[2].src"
                  :data-href="images[2].href">
                <img slot="preloader"
                  class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700 rounded-tr-xl"
                  loading="lazy" :src="mipmap(images[2].fullUrl, 10)" alt="" :key="'accopage' + images[2].src"
                  :data-href="images[2].href">
              </vue-load-image>
              <vue-load-image>
                <img slot="image"
                  class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable"
                  loading="eager" :src="mipmap(images[3].fullUrl, 400)" alt="" :key="'accopage' + images[3].src"
                  :data-href="images[3].href">
                <img slot="preloader"
                  class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700" loading="lazy"
                  :src="mipmap(images[3].fullUrl, 10)" alt="" :key="'accopage' + images[3].src"
                  :data-href="images[3].href">
              </vue-load-image>
              <vue-load-image>
                <img slot="image"
                  class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable rounded-br-xl"
                  loading="eager" :src="mipmap(images[4].fullUrl, 400)" alt="" :key="'accopage' + images[4].src"
                  :data-href="images[4].href">
                <img slot="preloader"
                  class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700 rounded-br-xl"
                  loading="lazy" :src="mipmap(images[4].fullUrl, 10)" alt="" :key="'accopage' + images[4].src"
                  :data-href="images[4].href">
              </vue-load-image>
            </div>
            <img v-for="(image, index) in images.slice(5)" :src="image.src" :key="index + '_' + image.src" loading="eager"
              :data-href="image.href" :alt="image.alt" />
            <div class="showall">{{ $t('Show all') }}</div>
          </div>
          <div v-else-if="images.length >= 3" class="imagebox mb-5 mt-6 md:my-10 rounded-lg max-h-[40vh] md2:max-h-[50vh]"
            v-viewer="viewerOptions">
            <vue-load-image>
              <img slot="image"
                class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable rounded-xl md2:rounded-r-none"
                :src="mipmap(images[0].fullUrl, 800)" alt="" :key="'accopage' + images[0].src" loading="eager"
                :data-href="images[0].href">
              <img slot="preloader"
                class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700 rounded-xl md2:rounded-r-none"
                loading="eager" :src="mipmap(images[0].fullUrl, 10)" alt="" :key="'accopage' + images[0].src"
                :data-href="images[0].href">
            </vue-load-image>
            <div class="grid">
              <vue-load-image class="!h-full">
                <img slot="image"
                  class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable"
                  loading="eager" :src="mipmap(images[1].fullUrl, 400)" alt="" :key="'accopage' + images[1].src"
                  :data-href="images[1].href">
                <img slot="preloader"
                  class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700" loading="lazy"
                  :src="mipmap(images[1].fullUrl, 10)" alt="" :key="'accopage' + images[1].src"
                  :data-href="images[1].href">
              </vue-load-image>
              <vue-load-image class="!h-full">
                <img slot="image"
                  class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable rounded-r-xl"
                  loading="eager" :src="mipmap(images[2].fullUrl, 400)" alt="" :key="'accopage' + images[2].src"
                  :data-href="images[2].href">
                <img slot="preloader"
                  class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700 rounded-r-xl"
                  loading="lazy" :src="mipmap(images[2].fullUrl, 10)" alt="" :key="'accopage' + images[2].src"
                  :data-href="images[2].href">
              </vue-load-image>
            </div>
            <img v-for="(image, index) in images.slice(3)" :src="image.src" :key="index + '_' + image.src" loading="eager"
              :data-href="image.href" :alt="image.alt" />
            <div class="showall">{{ $t('Show all') }}</div>
          </div>
          <div v-else-if="images.length == 1" class="imagebox mb-5 mt-6 md:my-10 rounded-lg max-h-[40vh] md2:max-h-[50vh]"
            v-viewer="viewerOptions">
            <vue-load-image>
              <img slot="image"
                class="w-full h-full object-cover animate-in fade-in duration-300 hover:scale-95 active:scale-75 unselectable rounded-xl md2:rounded-r-none"
                :src="mipmap(images[0].fullUrl, 800)" alt="" :key="'accopage' + images[0].src" loading="eager"
                :data-href="images[0].href">
              <img slot="preloader"
                class="w-full h-full object-cover animate-pulse blur-lg bg-gray-300 dark:bg-neutral-700 rounded-xl md2:rounded-r-none"
                loading="eager" :src="mipmap(images[0].fullUrl, 10)" alt="" :key="'accopage' + images[0].src"
                :data-href="images[0].href">
            </vue-load-image>
          </div>
        </div>
        <div class="row flex gap-2 acco_info">
          <div class="left_part">
            <div class="md:hidden mb-5" @click="openMenu()" v-if="!acco.url">
              <div class="text-white py-4 text-center rounded-xl bg-gradient shadow-xl">
                <div v-if="this.prices.price" class="booknowbottom">
                  <span>€ {{ (this.prices.roomPrice + extraCosts).toFixed(2) }} - {{ $t('Book now!') }}</span>
                </div>
                <span v-else>{{ $t('See availability') }}</span>
              </div>
            </div>
            <div v-else class="hidden sm:block md:hidden mb-5">
              <a target="_blank" :href="acco.url + '?referrer=' + referrer"
                class="block w-full bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
                <span>{{ $t('Go to website') }}</span>
              </a>
            </div>
            <div
              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md2:grid-cols-2 gap-2 dark:text-white md:w-[95%] mb-8">
              <div class="bg-white dark:bg-neutral-800 p-2 rounded-lg flex items-center gap-2 min-h-[80px] pr-4">
                <div class="image w-14 flex justify-center shrink-0">
                  <svg-vue class="w-6 !h-6 text-primary" v-if="hasIcon(acco.propertyType)"
                    :icon="'propTypes/' + acco.propertyType"></svg-vue>
                  <svg-vue class="w-6 !h-6 text-primary" v-else :icon="'propTypes/Home'"></svg-vue>
                </div>
                <div class="flex flex-col grow-0">
                  <span class="title">{{ $t(acco.propertyType) }}</span>
                  <span class="text-gray-400 dark:text-neutral-300 text-xs" v-if="Object.keys(acco.rooms).length == 1 &&
                    acco.rooms[Object.keys(acco.rooms)[0]].qty == 1
                    ">{{ $t("You will have") }} {{ $t("__" + acco.propertyType) | lowercase }}
                    {{ $t("to yourself.") }}
                  </span>
                  <span class="text-gray-400 dark:text-neutral-300 text-xs" v-else-if="Object.keys(acco.rooms).length == 1 &&
                    acco.rooms[Object.keys(acco.rooms)[0]].qty > 1
                    ">{{ $t('We have') }} {{ acco.rooms[Object.keys(acco.rooms)[0]].qty }}
                    {{ acco.propertyType }} {{ $t('listings to offer') }}</span>
                  <span class="text-gray-400 dark:text-neutral-300 text-xs" v-else>{{ $t('We have') }} {{
                    this.nmbrListings }}
                    {{ $t('listings to offer') }}
                  </span>
                </div>
              </div>
              <div class="bg-white dark:bg-neutral-800 p-2 rounded-lg flex items-center gap-2 min-h-[80px] pr-4"
                v-if="Object.keys(acco.rooms).length == 1">
                <div class="image w-14 flex justify-center shrink-0">
                  <svg-vue class="w-6 !h-6 text-primary" :icon="'people'"></svg-vue>
                </div>
                <div class="text grow-0">
                  <span class="title">{{ $t('Max') }} {{ acco.maxPeople }} {{ $tc('Guest', acco.maxPeople) }}</span>
                </div>
              </div>
              <div v-if="Object.keys(acco.rooms).length == 1 && bedrooms"
                class="bg-white dark:bg-neutral-800 p-2 rounded-lg flex items-center gap-2 min-h-[80px] pr-4">
                <div class="image w-14 flex justify-center shrink-0">
                  <svg-vue class="w-6 !h-6 text-primary" :icon="'bed'"></svg-vue>
                </div>
                <div class="flex flex-col grow-0">
                  <span class="title">{{ bedrooms }}</span>
                  <span class="text-gray-400 dark:text-neutral-300 text-xs">{{ $t('Setup:') }} {{
                    getBedroomInfo(acco.features)
                  }}</span>
                </div>
              </div>
              <div v-if="Object.keys(acco.rooms).length == 1 && bathrooms"
                class="bg-white dark:bg-neutral-800 p-2 rounded-lg flex items-center gap-2 min-h-[80px] pr-4">
                <div class="image w-14 flex justify-center shrink-0">
                  <svg-vue class="w-6 !h-6 text-primary" :icon="'bathroom'"></svg-vue>
                </div>
                <div class="flex flex-col grow-0">
                  <span class="title">{{ bathrooms }}</span>
                  <span class="text-gray-400 dark:text-neutral-300 text-xs">{{ $t('Setup:') }} {{
                    getBathroomInfo(acco.features)
                  }}</span>
                </div>
              </div>
              <div v-if="getLocation(acco.features).length > 0"
                class="bg-white dark:bg-neutral-800 p-2 rounded-lg flex items-center gap-2 min-h-[80px] pr-4">
                <div class="image w-14 flex justify-center shrink-0">
                  <svg-vue class="w-6 !h-6 text-primary" :icon="'location'"></svg-vue>
                </div>
                <div class="text grow-0">
                  <span class="title">{{ $t(getLocation(acco.features)) }}</span>
                </div>
              </div>
              <div v-if="iswheelchair(acco.features)"
                class="bg-white dark:bg-neutral-800 p-2 rounded-lg flex items-center gap-2 min-h-[80px] pr-4">
                <div class="image w-14 flex justify-center shrink-0">
                  <svg-vue class="w-6 !h-6 text-primary" :icon="'wheelchair'"></svg-vue>
                </div>
                <div class="text grow-0">
                  <span class="title">{{ $t('Wheelchair accessible') }} </span>
                </div>
              </div>
            </div>
              <VueReadMoreSmooth :no-shadow="false" :lines="8" v-if="hasDescription" class="[&>.hide-text]:!bg-gradient-to-t [&>.hide-text]:!from-gray-100 [&>.hide-text]:dark:!from-neutral-900 ">
                  <div class="dark:text-neutral-300 md:w-[95%]"
                          style="white-space: pre-line"
                          v-html="description"
                  ></div>

                  <template v-slot:more="value">
                      <div class="btn btn-lg btn--primary mt-4 mb-8 w-fit">
                          {{ value.open ? $t("Read less") : $t("Read more") }}
                      </div>
                  </template>
              </VueReadMoreSmooth>
            <div class="calendar part" v-if="!acco.url">
              <input type="hidden" id="datepickr_cal" name="checkin-out-cal" />
              <HotelDatePicker :alwaysVisible="true" :disabledDates="unavailable" :format="dateFormat"
                :lastDateAvailable="lastDateAvailable" :showYear="true" :firstDayOfWeek="1"
                :nextDisabledDate="nextDisabledDate" :minNights="roomMinNights" :selectForward="true"
                :startingDateValue="new Date(checkIn)" :endingDateValue="new Date(checkOut)" @dayClicked="handleDayClick"
                @period-selected="getSelectedDate">
              </HotelDatePicker>
            </div>
            <div class="part">
              <l-map class="map !h-[400px] rounded-md" :zoom="zoom" :center="center" :max-zoom="maxZoom"
                :options="{ scrollWheelZoom: false }">
                <l-tile-layer :url="url" :attribution="attribution" :accessToken="accessToken"></l-tile-layer>
                <l-marker v-for="(item, index) in markers" :key="'marker-' + index" :lat-lng="item">
                  <l-icon :icon-anchor="staticAnchor" class-name="markerClass">
                    <div class="marker"></div>
                  </l-icon>
                </l-marker>
              </l-map>
            </div>
          </div>
          <div class="bookingbox rounded-lg h-full backdrop-blur-sm bg-white dark:bg-neutral-800 dark:text-white md:mb-6"
            :class="{ show: menuOpen === true }">
            <div class="closebox text-white" @click="closeMenu()">
              <span>+</span>
            </div>
            <div class="inside bg-white dark:bg-neutral-800 md2:bg-none space-y-3">
              <div v-if="!acco.url" class="bg-gray-100 dark:bg-neutral-700 rounded-lg block p-1 relative ">
                <svg-vue class="w-6 !h-6 text-primary absolute left-3 top-5" :icon="'calendar'"></svg-vue>
                <HotelDatePicker ref="myDatePicker" class="dark:text-white rounded-lg" :alwaysVisible="false"
                  :disabledDates="unavailable" :format="dateFormat" :lastDateAvailable="lastDateAvailable"
                  :showYear="true" :showSingleMonth="true" :minNights="roomMinNights" :firstDayOfWeek="1"
                  :nextDisabledDate="nextDisabledDate" :selectForward="true" :startingDateValue="new Date(checkIn)"
                  :endingDateValue="new Date(checkOut)" @dayClicked="handleDayClick" @period-selected="getSelectedDate">
                </HotelDatePicker>
              </div>
              <div v-if="!acco.url"
                class="booking_spec_input_box p-4 space-y-2 bg-gray-100 dark:bg-neutral-700 rounded-lg dark:text-white"
                id="booking_spec_input_box">
                <div class="input_field">
                  <div class="value">
                    <span v-if="acco.maxChildren > 0" class="head">{{ $t('Adults') }} </span>
                    <span v-else>{{ $t('Guests') }}</span>
                    <span v-if="acco.maxChildren > 0" class="text-gray-400 dark:text-neutral-300">{{ $t('18+ years') }}
                    </span>
                  </div>
                  <div class="input_controls">
                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min w-10 h-10"
                      :class="numAdult == 1 ? 'disable' : ''" @click="decrementAdult()">
                      -
                    </div>
                    <input v-if="acco.maxAdult > acco.maxPeople" id="NumtempAdult" name="NumtempAdult" type="number"
                      min="0" v-bind:max="acco.maxAdult" v-bind:value="numAdult" />
                    <input v-else id="NumtempAdult" class="bg-transparent" name="NumtempAdult" type="number" min="1"
                      v-bind:max="acco.maxPeople" v-bind:value="numAdult" />
                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus w-10 h-10"
                      :class="numAdult == acco.maxPeople ? 'disable' : ''" @click="incrementAdult()">
                      +
                    </div>
                  </div>
                </div>
                <div v-if="acco.maxChildren > 0" class="input_field pt-4">
                  <div class="value">
                    <span class="head">{{ $t('Children') }} </span>
                    <span class="text-gray-400 dark:text-neutral-300">{{ $t('3 - 17 Years old') }} </span>
                  </div>
                  <div class="input_controls">
                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min w-10 h-10"
                      :class="numChildren == 0 ? 'disable' : ''" @click="decrementChildren()">
                      -
                    </div>
                    <input id="NumtempChild" name="NumtempChild" class="bg-transparent" type="number" min="0"
                      v-bind:max="acco.maxChildren" v-bind:value="numChildren" />
                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus w-10 h-10"
                      :class="numChildren == acco.maxChildren ? 'disable' : ''" @click="incrementChildren()">
                      +
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="this.prices.price"
                class="detail_field px-2 text-base dark:text-white rounded-lg border border-gray-300 dark:border-neutral-600">
                <ul>
                  <li class="flex md:flex-col md2:flex-row py-4">
                    <span class="md:text-xs md2:text-base">{{ $t('Price accomodation') }}</span>
                    <span v-if="this.prices.multiplier < 1">€ {{ this.prices.originalPrice.toFixed(2) }}</span><span
                      v-else>€ {{ this.prices.roomPrice.toFixed(2) }}</span>
                  </li>
                  <li class="discount flex md:flex-col md2:flex-row" v-if="this.prices.multiplier < 1">
                    <span class="md:text-xs md2:text-base">{{ ((1 - this.prices.multiplier) * 100).toFixed(0) }}%
                      {{ $t('Discount!') }} </span>
                    <span>€ -{{
                      (
                        this.prices.originalPrice / this.prices.multiplier -
                        this.prices.originalPrice
                      ).toFixed(2)
                    }}</span>
                  </li>
                  <li class="flex md:flex-col md2:flex-row py-4" v-for="(item, index) in only_oblg(this.prices.upsell)"
                    :key="index">
                    <span class="md:text-xs md2:text-base"
                      v-if="item.description && item.description[htmlLang].length != 0">{{ item.description[htmlLang]
                      }}</span>
                    <span class="md:text-xs md2:text-base"
                      v-else-if="item.description && item.description['EN'].length != 0">{{ item.description['EN']
                      }}</span>
                    <span class="md:text-xs md2:text-base"
                      v-else-if="item.description && item.description['en'].length != 0">{{ item.description['en']
                      }}</span>
                    <span v-if="item.period == 1 && item.unit == 1">€
                      {{
                        (
                          Number(item.price) *
                          moment(new Date(checkOut)).diff(
                            moment(new Date(checkIn)),
                            "days"
                          ) *
                          (Number(numAdult) + Number(numChildren))
                        ).toFixed(2)
                      }}</span>
                    <span v-else-if="item.period == 1">€ {{ Number(item.price).toFixed(3) }}</span>
                    <span v-else>€ {{ Number(item.price).toFixed(2) }}</span>
                  </li>
                  <li class="suggestion flex md:flex-col md2:flex-row py-4" v-if="this.prices.suggest &&
                    this.prices.suggest.days >
                    moment(new Date(checkOut)).diff(
                      moment(new Date(checkIn)),
                      'days'
                    ) &&
                    this.prices.suggest.days -
                    moment(new Date(checkOut)).diff(
                      moment(new Date(checkIn)),
                      'days'
                    ) <
                    3
                    ">
                    {{ $t('Add') }}
                    {{
                      this.prices.suggest.days -
                      moment(new Date(checkOut)).diff(
                        moment(new Date(checkIn)),
                        "days"
                      )
                    }}
                    <span>{{ $tc('Day', moment(new Date(checkOut)).diff(
                      moment(new Date(checkIn)),
                      'days'
                    )) }}</span> {{ $t('to get a discount!') }}
                  </li>
                  <li
                    class="border-t-2 border-dotted border-gray-400 dark:border-neutral-700 flex md:flex-col md2:flex-row py-4">
                    <span class="md:text-xs md2:text-base">{{ $t('Total Price') }}</span>
                    <span>€ {{ (this.prices.price).toFixed(2) }}</span>
                  </li>
                </ul>
              </div>
              <a v-if="acco.url" target="_blank" :href="acco.url + '?referrer=' + referrer"
                class="block bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
                <span>{{ $t('Go to website') }}</span>
              </a>
              <a v-else-if="acco.use_new_engine && this.prices.price" @click="send_buy_conversion(getNewBookingUrl())"
                :href="getNewBookingUrl()" target="_blank"
                class="block bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
                <span>{{ $t('Book now') }}</span>
              </a>
              <div v-else-if="acco.use_new_engine && notAvailable" class="errorField rounded-lg">
                {{ notAvailable }}
              </div>
              <a v-else-if="this.prices.price" target="_blank"
                @click="send_buy_conversion(`https://admin.boostmybookings.com/booking2.php?referer=${referrer}&propid=${acco.propID}&checkin=${moment(new Date(this.checkIn)).format('YYYYMMDD')}&checkout=${moment(new Date(this.checkOut)).format('YYYYMMDD')}&numadult=${this.numAdult}&numChildren=${this.numChildren}`)"
                :href="`https://admin.boostmybookings.com/booking2.php?referer=${referrer}&propid=${acco.propID}&checkin=${moment(new Date(this.checkIn)).format('YYYYMMDD')}&checkout=${moment(new Date(this.checkOut)).format('YYYYMMDD')}&numadult=${this.numAdult}&numChildren=${this.numChildren}`"
                class="block bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
                <span>{{ $t('Book now') }}</span>
              </a>
              <div v-else-if="notAvailable" class="errorField rounded-lg">
                {{ notAvailable }}
              </div>
              <div
                class="detail_field p-2 text-sm dark:text-white rounded-lg border border-gray-300 dark:border-neutral-600">
                <div class="head">{{ $t('Check in') }}</div>
                {{ $t('Check in from') }}
                {{ moment(acco.checkinstart, "HH:mm:ss").format("HH:mm") }}.
                {{ $t('Check out until') }}
                {{ moment(acco.checkoutend, "HH:mm:ss").format("HH:mm") }}
              </div>
              <div v-if="acco.policy || acco.houserules"
                class="detail_field p-2 text-sm dark:text-white rounded-lg border border-gray-300 dark:border-neutral-600">
                <div class="head">{{ $t('Extra information') }}</div>
                <div class="flex flex-col">

                  <a v-if="acco.policy" class="hover:underline text-primary py-1"
                    v-bind:href="`${currentUrl}/accomodations/${acco.id}/cancellation`">
                    {{ $t('Cancellation policy') }}.</a>
                  <a v-if="acco.houserules" class="hover:underline text-primary py-1"
                    v-bind:href="`${currentUrl}/accomodations/${acco.id}/houserules`">{{ $t('Houserules') }}.</a>
                </div>
              </div>
              <input type="hidden" name="product_id" class="hidden" value="28" />
              <div
                class="detail_field p-2 text-sm dark:text-white rounded-lg border border-gray-300 dark:border-neutral-600">
                <div class="head">{{ $t('Ask a question') }}</div>
                <form action="/ask" method="post" class="w-full max-w-2xl mx-auto askaquestion">
                  <input type="hidden" name="_token" :value="csrf" />
                  <input type="hidden" name="accomodation" :value="acco.name" />
                  <input
                    class="w-full appearance-none block w-full bg-gray-200 dark:bg-neutral-600  text-gray-700 dark:text-white border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white dark:focus:bg-neutral-900 focus:border-primary"
                    name="name" id="name" value="" :placeholder="$t('Name')" type="text" /><br />
                  <input
                    class="w-full appearance-none block w-full bg-gray-200 dark:bg-neutral-600  text-gray-700 dark:text-white border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white dark:focus:bg-neutral-900 focus:border-primary"
                    name="email" id="email" value="" :placeholder="$t('Email')" type="email" /><br />
                  <textarea
                    class="w-full appearance-none block w-full bg-gray-200 dark:bg-neutral-600 text-gray-700 dark:text-white border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white dark:focus:bg-neutral-900 focus:border-primary"
                    name="message" id="message" value="" :placeholder="$t('Message')" type="message"></textarea><br />
                  <button class="btn btn-lg btn--primary w-full">{{ $t('send') }}</button>
                </form>
              </div>


              <div class="flex flex-gap md2:hidden w-full justify-center gap-4 mt-4">
                <a :href="`https://x.com/share?url=${currentUrl}/accomodations/${acco.id}&text=${acco.name}`"
                  target="_blank"
                  class="mx1 py-2 hover:scale-95 active:scale-75 transition duration-300 cursor-pointer dark:text-white">
                  <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 1200 1227" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
                  </svg>

                </a>
                <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}/accomodations/${acco.id}`"
                  target="_blank"
                  class="mx1  py-2 hover:scale-95 active:scale-75 transition duration-300 cursor-pointer hover:brightness-125">
                  <img class="w-6 h-6" v-bind:src="currentUrl + '/images/icons/facebook.svg'" alt="" srcset="" />
                </a>
                <div v-if="webShareApiSupported" @click.prevent="shareViaWebShare()" class="mx1 pointer py-2">
                  <img class="w-6 h-6" v-bind:src="currentUrl + '/images/icons/share.svg'" alt="" srcset="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="fullpageLoader">
      <svg aria-hidden="true" class="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-primary"
        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor" />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill" />
      </svg>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import HotelDatePicker from "vue-hotel-datepicker";
import "vue-hotel-datepicker/dist/vueHotelDatepicker.css";
import Helpers from "../helpers";
import moment from "moment";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import VueMeta from "vue-meta";
import VueLoadImage from 'vue-load-image'

Vue.use(Viewer);
Vue.use(VueMeta);

import VueReadMoreSmooth from "vue-read-more-smooth";
import VueCookies from 'vue-cookies'

Vue.prototype.moment = moment;
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    HotelDatePicker,
    VueLoadImage,
    VueReadMoreSmooth
  },
  props: {
    listing: {
      type: Number,
      default: -1
    },
    lastDateAvailable: {
      type: [Number, Date],
      default: Infinity,
    },
    referrer: "",
  },
  data() {
    let format = "YYYY-MM-DD";
    let today = moment();
    return {
      metaTitle: "",
      metaDescription: "",
      sortBy: "name",
      keyword: "",
      staticAnchor: [16, 37],
      dataloaded: false,
      url: "https://tile.jawg.io/241a2530-2ad8-4bbe-b7ab-cc3dc94c489b/{z}/{x}/{y}{r}.png?access-token=vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa",
      attribution:
        '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributorss',
      zoom: 13,
      maxZoom: 18,
      minZoom: 4,
      accessToken: 'vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa',
      markers: [],
      checkIn: VueCookies.isKey('checkin') ? moment(VueCookies.get('checkin')).format(format) : today.add(1, "days").format(format),
      checkOut: VueCookies.isKey('checkout') ? moment(VueCookies.get('checkout')).format(format) : today.add(3, "days").format(format),
      checkInTemp: null,
      checkOutTemp: null,
      checkinPopup: null,
      checkoutPopup: null,
      checkinCalendar: null,
      products: null,
      checkoutCalendar: null,
      currentUrl: "",
      htmlLang: "",
      params: [],
      numAdult: VueCookies.isKey('numAdult') ? VueCookies.get('numAdult') : 2,
      numChildren: VueCookies.isKey('numChildren') ? VueCookies.get('numChildren') : 0,
      numAdultTemp: null,
      numChildrenTemp: null,
      bathrooms: null,
      notAvailable: null,
      extraCosts: 0,
      nmbrListings: -1,
      nextDisabledDate: null,
      roomMinNights: 1,
      unavailable: [],
      prices: [],
      roomID: null,
      menuOpen: false,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      viewerOptions: {
        movable: true,
        rotatable: true,
        scalable: true,
        url: "data-href",
        title(image, imageData) {
          return image.alt;
        },
      },
      periodDates: [],
    };
  },

  methods: {
    ...Helpers,
    only_oblg(items) {
      var returnFeatures = new Array();
      for (var item in items) {
        if (items[item].type != 3 && items[item].type != 1 && items[item].type != 5 && items[item].type != 0) {
          returnFeatures.push(items[item]);
        }
      }
      return returnFeatures;
    },
    send_buy_conversion() {
      if (this.$attrs.book_conversion_tag) {
        console.log("conversion");
        var callback = function () {
          if (typeof (url) != 'undefined') {
            window.location = url;
          }
        };
        gtag('event', 'conversion', {
          'send_to': this.$attrs.book_conversion_tag,
          'value': this.prices && this.prices.price ? (this.prices.price).toFixed(2) : null,
          'currency': 'EUR',
          'event_callback': callback
        });
      }
      return false;
    },
    async shareViaWebShare() {
      try {
        await navigator.share({
          title: this.acco.name,
          text: this.acco.name,
          url: `${this.currentUrl}/accomodations/${this.acco.id}`,
        });
      } catch (err) {
        console.log(err);
      }
    },
    openMenu() {
      this.menuOpen = true;
      $("body").addClass("viewer-open");
    },
    closeMenu() {
      this.menuOpen = false;
      $("body").removeClass("viewer-open");
    },
    async calculatePrice() {
      if (moment(new Date(this.checkIn)) < moment(new Date(this.checkOut))) {
        if (
          this.checkIn != this.checkInTemp ||
          this.checkOut != this.checkOutTemp ||
          this.numAdultTemp != this.numAdult ||
          this.numChildrenTemp != this.numChildren
        ) {
          this.checkInTemp = this.checkin;
          this.checkOutTemp = this.checkOut;
          this.numAdultTemp = this.numAdult;
          this.numChildrenTemp = this.numChildren;

          var url = 
          this.$BMB_API +'api/' +
          this.$clientID +
            "/getPrice/" +
            this.products.id +
            "?checkin=" +
            moment(new Date(this.checkIn)).format("YYYYMMDD") +
            "&checkout=" +
            moment(new Date(this.checkOut)).format("YYYYMMDD") +
            "&numadult=" +
            this.numAdult +
            "&numchildren=" +
            this.numChildren;


          if (this.roomID) {
            url += "&roomID=" + this.roomID;
          }

          let response = await fetch(
            url,
            {
              headers: {
                "Content-Type": "text/plain",
                "Accept-Language": document.documentElement.lang
              },
            }
          );
          response = await response.json();

          if (Object.keys(response).length == 1) {
            this.notAvailable = response.message;
          } else {
            this.notAvailable = null;
          }
          this.roomMinNights = response.roomMinNights;
          var tempcosts = 0;

          for (const item in response.upsell) {
            if (response.upsell[item].type > 1) {
              if (
                response.upsell[item].period == 1 &&
                response.upsell[item].unit == 1
              ) {
                tempcosts +=
                  Number(response.upsell[item].price) *
                  moment(new Date(this.checkOut)).diff(
                    moment(new Date(this.checkIn)),
                    "days"
                  ) *
                  (Number(this.numAdult) + Number(this.numChildren));
              } else if (
                response.upsell[item].period == 1 &&
                response.upsell[item].unit != 1
              ) {
                tempcosts += Number(response.upsell[item].price);
              } else {
                tempcosts += Number(response.upsell[item].price);
              }
            }
          }

          if (tempcosts !== this.extraCosts) {
            this.extraCosts = tempcosts;
          }
          if (
            JSON.stringify(response) !== JSON.stringify(this.prices)
          ) {
            this.prices = response;
          }
        }
      }
    },
    incrementAdult() {
      if (
        this.numAdult < this.acco.maxAdult ||
        this.numAdult < this.acco.maxPeople
      ) {
        this.numAdult++;
      }
      VueCookies.set('numAdult', this.numAdult);
      this.calculatePrice();
    },
    decrementAdult() {
      if (this.numAdult > 1) {
        this.numAdult--;
      }
      VueCookies.set('numAdult', this.numAdult);
      this.calculatePrice();
    },
    incrementChildren() {
      if (this.numChildren < this.acco.maxChildren) {
        this.numChildren++;
      }
      VueCookies.set('numChildren', this.numChildren);
      this.calculatePrice();
    },
    decrementChildren() {
      if (this.numChildren > 1) {
        this.numChildren--;
      }
      VueCookies.set('numChildren', this.numChildren);
      this.calculatePrice();
    },
    iswheelchair: function (string) {
      var features = JSON.parse(string);
      for (var index in features) {
        if (features[index] == "WHEELCHAIR_YES") {
          return true;
        }
      }
      return false;
    },
    getNewBookingUrl() {
      if (Object.keys(this.products.rooms).length == 1) {
        var url =           this.$BMB_API +
          'book/' + this.$clientID;

        url += '/details/';
        url += '?checkin=' + moment(new Date(this.checkIn)).format("YYYY-MM-DD") + '&checkout=' + moment(new Date(this.checkOut)).format("YYYY-MM-DD");
        url += '&numAdult=' + this.numAdult + '&numChildren=' + this.numChildren;
        url += '&setup=' + this.roomID + '_1_' + this.numAdult + ',' + this.numChildren;
        return url;
      } else {
        var url = '/book/' + this.$clientID;

        url += '?show_props=' + this.products.id;
        url += '&checkin=' + moment(new Date(this.checkIn)).format("YYYY-MM-DD") + '&checkout=' + moment(new Date(this.checkOut)).format("YYYY-MM-DD");
        url += '&numAdult=' + this.numAdult + '&numChildren=' + this.numChildren;
        return url;
      }
    },
    getBedrooms: function (string) {
      var features = JSON.parse(string);
      var returnFeatures = new Array();
      for (var index in features) {
        if (features[index].length > 1 && features[index].includes("BEDROOM")) {
          returnFeatures.push(features[index]);
        }
      }
      if (returnFeatures.length) {
        return returnFeatures.length + " " + this.$tc("bedroom", returnFeatures.length);
      } else {
        return 0;
      }
    },
    getBedroomInfo: function (string) {
      var features = JSON.parse(string);
      var bedrooms = new Array();
      for (var index in features) {
        if (features[index].length > 1 && features[index].includes("BEDROOM") || features[index].includes('BEDROOM_LIVING_SLEEPING_COMBO')) {
          bedrooms.push(features[index]);
        }
      }
      var returnArray = new Array();
      for (var index in bedrooms) {
        if (bedrooms[index].length > 1) {
          var room = new Array();
          var exclude_items = new Array();

          for (var index2 in bedrooms[index]) {
            if (
              bedrooms[index][index2] != "BEDROOM_LIVING_SLEEPING_COMBO" &&
              bedrooms[index][index2] != "BEDROOM" &&
              (exclude_items.length < 1 ||
                !exclude_items.includes(bedrooms[index][index2]))
            ) {
              var parts = bedrooms[index][index2].split("_");
              var count = bedrooms[index].filter(
                (v) => v === bedrooms[index][index2]
              ).length;
              if (count > 1) {
                exclude_items.push(bedrooms[index][index2]);
                room.push(
                  this.$t(bedrooms[index][index2]) +
                  "(" +
                  count +
                  "x)"
                );
              } else {
                room.push(
                  this.$t(bedrooms[index][index2])
                );
              }
            }
          }
          returnArray.push(room.join(" " + this.$t("and") + " "));
        }
      }
      return returnArray.join(", ");
    },
    getBathrooms: function (string) {
      var features = JSON.parse(string);
      var returnFeatures = new Array();
      for (var index in features) {
        if (
          features[index].length > 1 &&
          (features[index].includes("BATHROOM") ||
            features[index].includes("BATHROOM_FULL") ||
            features[index].includes("BATHROOM_SHOWER"))
        ) {
          returnFeatures.push(features[index]);
        }
      }
      if (returnFeatures.length) {
        return returnFeatures.length + " " + this.$tc("bathroom", returnFeatures.length);
      } else {
        0;
      }
    },
    getBathroomInfo: function (string) {
      var features = JSON.parse(string);
      var bathrooms = new Array();
      for (var index in features) {
        if (
          features[index].length > 1 &&
          (features[index].includes("BATHROOM") ||
            features[index].includes("BATHROOM_FULL") ||
            features[index].includes("BATHROOM_SHOWER"))
        ) {
          bathrooms.push(features[index]);
        }
      }
      var returnArray = new Array();
      for (var index in bathrooms) {
        if (bathrooms[index].length > 1) {
          if (bathrooms[index].includes("BATH_COMBO_TUB_SHOWER")) {
            returnArray.push(this.$t("Bath/shower combo"));
          }
          if (bathrooms[index].includes("BATH_SHOWER")) {
            returnArray.push(this.$t("Shower"));
          }
          if (
            bathrooms[index].includes("BATH") ||
            bathrooms[index].includes("BATH_TUB")
          ) {
            returnArray.push(this.$t("Bath"));
          }
          if (bathrooms[index].includes("SHOWER")) {
            returnArray.push(this.$t("Shower"));
          }
          if (bathrooms[index].includes("BIDET")) {
            returnArray.push(this.$t("Bidet"));
          }
          if (bathrooms[index].includes("TOILET")) {
            returnArray.push(this.$t("Toilet"));
          }
          if (bathrooms[index].includes("JETTED_TUB")) {
            returnArray.push(this.$t("Jacuzzi"));
          }
          if (bathrooms[index].includes("OUTDOOR_SHOWER")) {
            returnArray.push(this.$t("Outdoor shower"));
          }
        }
      }
      return returnArray.join(", ");
    },
    getLocation: function (string) {
      var features = JSON.parse(string);
      var returnFeatures = new Array();
      var locations = [
        "BEACH",
        "BEACH_FRONT",
        "BEACH_VIEW",
        "CITY",
        "DOWNTOWN",
        "GOLF_COURSE_FRONT",
        "GOLF_COURSE_VIEW",
        "LAKE",
        "LAKE_FRONT",
        "LAKE_VIEW",
        "MONUMENT_VIEW",
        "MOUNTAIN",
        "MOUNTAIN_VIEW",
        "NEAR_OCEAN",
        "OCEAN_FRONT",
        "OCEAN_VIEW",
        "RESORT",
        "RIVER",
        "RURAL",
        "SKI_IN",
        "SKI_OUT",
        "TOWN",
        "VILLAGE",
        "WATER_VIEW",
        "WATER_FRONT",
      ];
      for (var index in features) {
        if (
          features[index].length == 1 &&
          locations.includes(features[index][0])
        ) {
          returnFeatures.push(features[index][0]);
        }
      }
      if (returnFeatures[0]) {
        return returnFeatures[0];
      } else {
        return "";
      }
    },
    hasIcon: function (string) {
      var icons = ["Boat", "Car rental"];
      if (icons.includes(string)) {
        return 1;
      } else {
        return 0;
      }
    },
    getUSPFeatures: function (string) {
      var features = JSON.parse(string);
      const usps = [
        "LIVING_ROOM",
        "FIREPLACE",
        "PRIVATE_YARD",
        "VIDEO_ON_DEMAND",
        "WIFI",
        "KITCHEN",
        "PARKING_INCLUDED",
        "PETS_CONSIDERED",
        "WHEELCHAIR_YES",
        "BALCONY",
      ];
      var returnFeatures = new Array();
      for (var index in features) {
        if (features[index].length == 1 && usps.includes(features[index][0])) {
          returnFeatures.push(features[index]);
        }
      }
      return returnFeatures;
    },

    async getData() {
      try {
        let response = await fetch(
          this.$BMB_API +'api/' +
          this.$clientID +
          "/getProperty/" +
            this.listing +
          "/?getPrices=True",
          {
            headers: {
              "Content-Type": "text/plain",
              "Accept-Language": document.documentElement.lang
            },
          }
        );
        this.products = await response.json();

        if (Object.keys(this.products.rooms).length == 1) {
          this.roomID = this.products.rooms[Object.keys(this.products.rooms)[0]].id;
        }

        var moment = require("moment");

        let format = "YYYY-MM-DD"; //<-- Change this to the date format your using for your project, otherwise this doesn't matter keep it the same.
        let today = moment(); //Gets today's date in a moment object
        today.subtract(1, "days").format(format); //Subtract a day, then format to whatever your 'lockDaysFormat' string is.
        this.unavailable = this.products.unavailable;
        this.calculatePrice()

        this.nmbrListings = Object.values(this.products.rooms).length;
        this.dataloaded = true;
      } catch (error) {
        console.log(error);
        this.dataloaded = true;
      }

      this.markers.push([this.products.latitude, this.products.longitude]);
      this.center = this.markers[0];
    },
    getSelectedDate(event, checkinDate, checkoutDate) {
      this.checkIn = checkinDate;
      this.checkOut = checkoutDate;
      VueCookies.set('checkin', moment(checkinDate).format("YYYYMMDD"));
      VueCookies.set('checkout', moment(checkoutDate).format("YYYYMMDD"));
      this.calculatePrice();
    },
    handleDayClick(event, date, formatDate, resetCheckin) {
      this.nextPeriodDisableDates = [];
      if (resetCheckin) {
        this.clearSelection();
        this.$nextTick(() => {
          this.handleDayClick(event, date, formatDate, false);
        });
        this.unavailable = this.acco.unavailable;
        return;
      }
      let nextDisabledDate =
        (this.maxNights ? this.addDays(date, this.maxNights + 1) : null) ||
        this.getNextDate(this.unavailable, date) ||
        this.nextBookingDate(date) ||
        Infinity;

      this.dynamicNightCounts = null;
      if (this.enableCheckout) {
        nextDisabledDate = Infinity;
      }
      var newdate = new Date(nextDisabledDate);
      var year = newdate.getFullYear();
      var month = newdate.getMonth();
      var day = newdate.getDate();
      for (
        var arr = [], dt = newdate;
        dt <= new Date(year, month + 3, day);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(
          newdate.getFullYear() +
          "-" +
          ("0" + (newdate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + newdate.getDate()).slice(-2)
        );
      }

      for (
        arr, dt = new Date(date);
        dt > new Date(year, month - 3, day);
        dt.setDate(dt.getDate() - 1)
      ) {
        arr.push(
          dt.getFullYear() +
          "-" +
          ("0" + (dt.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + dt.getDate()).slice(-2)
        );
      }

      if (this.checkIn == null && !this.singleDaySelection) {
        this.checkIn = date;
        this.unavailable = arr;
        this.$emit("check-in-selected", date);
      } else if (this.singleDaySelection) {
        this.checkIn = date;
        this.unavailable = arr;
        this.$emit("check-in-selected", date);
        this.checkOut = date;
      } else if (
        this.checkIn !== null &&
        this.checkOut == null &&
        this.isDateLessOrEquals(date, this.checkIn)
      ) {
        this.checkIn = this.checkIn;
        this.$emit("check-in-selected", date);
      } else if (this.checkIn !== null && this.checkOut == null) {
        this.checkOut = date;
        this.unavailable = this.acco.unavailable;
        this.$emit("period-selected", event, this.checkIn, this.checkOut);
        /**
         * @deprecated since v4.0.0 beta 11
         */
        this.$emit("periodSelected", event, this.checkIn, this.checkOut);
      } else {
        this.checkinPopup = date;
        this.checkoutPopup = null;
        // this.unavailable = arr;
        this.$emit("check-in-selected", date);
      }
    },
  },

  created() {
    this.getData();
    this.currentUrl = window.location.origin;
    this.htmlLang = document.documentElement.lang.toUpperCase();
    // setTimeout(function () {
    //   this.unavailable = this.acco.unavailable;
    // }, 200);

    this.params = new URLSearchParams(document.location.search);

    if (this.params.get("checkin")) {
      this.checkIn = new Date(
        this.params.get("checkin").substring(0, 4) +
        "-" +
        this.params.get("checkin").substring(4, 6) +
        "-" +
        this.params.get("checkin").substring(6, 8)
      );
    }
    if (this.params.get("checkout")) {
      this.checkOut = new Date(
        this.params.get("checkout").substring(0, 4) +
        "-" +
        this.params.get("checkout").substring(4, 6) +
        "-" +
        this.params.get("checkout").substring(6, 8)
      );
    }
    if (this.params.get("numAdults")) {
      this.numAdult = this.params.get("numAdults");
    }
    if (this.params.get("numChildren")) {
      this.numChildren = this.params.get("numChildren");
    }
  },

  filters: {
    lowercase: function (string) {
      return string.toLowerCase();
    },
  },

  computed: {
    webShareApiSupported() {
      return navigator.share
    },
    acco: function () {
      if (this.dataloaded) {
        this.bathrooms = this.getBathrooms(this.products.features)
        this.bedrooms = this.getBedrooms(this.products.features)
        this.metaTitle =
          this.products.name + " - " + this.products.city + " - ";
        var description = this.htmlLang in JSON.parse(this.products.description) ? JSON.parse(this.products.description)[
          this.htmlLang
        ] : 'EN' in JSON.parse(this.products.description) ? JSON.parse(this.products.description)[
          'EN'
        ] : JSON.parse(this.products.description)[
        'en'
        ];

        if (this.metaDescription) {
          this.metaDescription = description.substring(0, 160)
        }
        return this.products;
      }
    },
    images: function () {
      if (this.dataloaded) {
        var content = JSON.parse(this.products.images);
        var imageArray = [];
        var external = Object.values(content.external);
        var hosted = Object.values(content.hosted);
        var images = hosted.concat(external);

        images = images.sort(function (a, b) {
          try {
            if (a.map.includes(0)) {
              if (a.map[0].position === b.map[0].position) {
                return 0;
              }
              else {
                return (a.map[0].position < b.map[0].position) ? -1 : 1;
              }
            } else {
              if (b.map.includes(0)) {
                return -1;
              } else {
                if (JSON.parse(a.map).position === JSON.parse(b.map).position) {
                  return 0;
                }
                else {
                  return (JSON.parse(a.map).position < JSON.parse(b.map).position) ? -1 : 1;
                }
              }
            }
          } catch (e) {
            return -1;
          }
        })

        for (var index in images) {
          if (!images[index].url.includes('https://media.xmlcal.com')) {
            if (images[index].url) {
              var object = {
                src: images[index].url,
                href: images[index].url,
                fullUrl: images[index].url,
                alt: "",
              };
              imageArray.push(object);
            }
          } else {
            if (images[index].url) {
              var imgblocks = images[index].url.split("/");
              var imgfile = imgblocks[imgblocks.length - 1];
              var thumbnailimgsmall =
                imgfile.split(".")[0] + ".100." + imgfile.split(".")[1];
              imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
              var thumbnailurlsmall = imgblocks.join("/");

              var thumbnailimg =
                imgfile.split(".")[0] + ".800." + imgfile.split(".")[1];

              imgblocks[imgblocks.length - 1] = imgfile;
              var fullUrl = imgblocks.join("/");

              imgblocks[imgblocks.length - 1] = thumbnailimg;
              var thumbnailurl = imgblocks.join("/");
              var object = {
                src: thumbnailurlsmall,
                href: thumbnailurl,
                fullUrl: fullUrl,
                alt: "",
              };
              imageArray.push(object);
            }
          }
        }

        return imageArray;
      }
    },
    dateFormat() {
      return "YYYY-MM-DD";
    },
      description() {
          if (this.acco.description) {
              const parsedDescription = JSON.parse(this.acco.description);
              // Check if the description exists in the current language
              if (this.htmlLang in parsedDescription && parsedDescription[this.htmlLang]) {
                  return parsedDescription[this.htmlLang];
              } else if ('EN' in parsedDescription && parsedDescription['EN']) {
                  return parsedDescription['EN'];
              }
          }
          return '';
      },
      hasDescription() {
          return this.description.length > 0; // Check if description is not empty
      },
  },
};
</script>
